import { render } from "./EmbeddedCodes.vue?vue&type=template&id=3ea416cf"
import script from "./EmbeddedCodes.vue?vue&type=script&lang=js"
export * from "./EmbeddedCodes.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__